export default __webpack_public_path__ + "static/1-36-0-new-funnel-viz-d9b7f940be6426c5826b299bffa81d97.png";